import { render, staticRenderFns } from "./SalesDashboard.vue?vue&type=template&id=bd0868c0&"
import script from "./SalesDashboard.vue?vue&type=script&lang=js&"
export * from "./SalesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SalesDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QBreadcrumbs,QBreadcrumbsEl,QToggle,QBtn,QIcon,QTab} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBreadcrumbs,QBreadcrumbsEl,QToggle,QBtn,QIcon,QTab})
